import React, { useEffect, useState } from 'react';

import { useLocation  } from 'react-router-dom';

import NavBarTabaItems from './NavBarTabaItems';
import TamztitTabalInfo from './TamztitTabalInfo';
// import ProcessInfo from '../RishuiBnia/ProcessInfo';
import ProcessInfoContainer from '../RishuiBnia/ProcessInfoContainer';
import VahadaInfo from '../RishuiBnia/VahadaInfo';
import ArchivInfo from '../RishuiBnia/ArchivInfo';
import TeurInfo from './TeurInfo';
import LocationInfo from '../RishuiBnia/LocationInfo';
import HavotDaatInfo from './HavotDaatInfo';
import YahasTohnitInfo from './YahasTohnitInfo';


const NavBarTabaContainer = (props) => {
    const [componentName, setComponentName] = useState("");
    const { search } = useLocation();

    useEffect(() => {
        const compName = new URLSearchParams(search).get("Page");
        setComponentName(compName);

        // return () => {
        //     console.log('prev compName: ', compName);
        //   }
    }, []);
    
    useEffect(() => {
        if(props.pageEvent === 'Header') {
            window.location.reload();
        }
    }, [props]);

    const renderComponent = (compName) => {
        let componentToRender;

        switch (compName) {
            case "ProcessInfo":
                // componentToRender = <ProcessInfo />;
                componentToRender = <ProcessInfoContainer />;
                break;
            case "VahadaInfo":
                componentToRender = <VahadaInfo />;
                break;
            case "TamztitTabalInfo":
                componentToRender = <TamztitTabalInfo />;
                break;
            case "ArchivInfo": 
                componentToRender = <ArchivInfo />; 
                break;
            case "TeurInfo":
                componentToRender = <TeurInfo />
                break;
            case "LocationInfo": 
                componentToRender = <LocationInfo />; 
                break;
            case "HavotDaatInfo": 
                componentToRender = <HavotDaatInfo />; 
                break;
            case "YahasTohnitInfo": 
                componentToRender = <YahasTohnitInfo />; 
                break;
            default:
                componentToRender = <div>אדם חכם אמר פעם: "לעולם אל תסמוך על דף שאינך יכול למצוא"</div>
                break;
        }

        return componentToRender;
    }

    const changeComponent = (name) => {
        // console.log('name', name);
        setComponentName(name);
    }

    return (
        <>
            <NavBarTabaItems componentName={componentName} changeComponent={changeComponent}/>
            <div className="container my-3 my-lg-5">
                {renderComponent(componentName)}
            </div>
        </>
    )
}

export default NavBarTabaContainer